import React from "react";
import { Async } from "react-select";
import Overlay from "../../../components/overlay";
import Dialog from "../../../components/dialog";
import { getStores } from "../../../backend/stores";
import MachineSwap from "../machine-swap";

export default function() {
  const {
    machines = [],
    storeSelect,
    loading,
    showSwapOverlay,
    store,
    machineSwapId
  } = this.state;
  return (
    <div>
      <label>Store Location {this._getStoreHours(store)}</label>
      <Async
        value={storeSelect}
        loadOptions={getStores}
        onChange={this._selectStore}
      />
      <div>
        {loading && <Overlay />}
        {machines.length === 0 &&
          !loading && (
            <div className="placeholder">
              {navigator.onLine ? "No machines" : "Could not retreive machines"}
            </div>
          )}
        {machines.map((machine, index) => this._renderMachine(machine, index))}
      </div>
      {showSwapOverlay && (
        <Dialog close={this._closeSwapDialog}>
          <MachineSwap
            machineId={machineSwapId}
            closeDialog={this._closeSwapDialog}
          />
        </Dialog>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/machines/machine-list/view.js